import { useEffect, useRef } from 'react';

/**
 * Run a function when prop has changed.
 * eg. re-calculate something when prop `isLoading` has changed.
 */
export const useOnPropChanged = <T>(prop: T, onChange: (prev: T, current: T) => void): void => {
  const prevRef = useRef(prop);
  useEffect(() => {
    const prev = prevRef.current;
    if (prev !== prop) {
      prevRef.current = prop;
      onChange(prev, prop);
    }
  }, [onChange, prop]);
};
